// extracted by mini-css-extract-plugin
export default {"subLine":"CardView_subLine__khmfx","projects":"CardView_projects__N3K6g","project":"CardView_project__XgLUt","body":"CardView_body__Gnwme"};